import * as React from 'react'
import { getTimeZoneOptions } from './TimeZones'
import YumSelect, { YumSelectProps } from '../YumSelect/YumSelect'
import { t } from 'ttag'

import { ReactComponent as TimeZoneActiveIcon } from '../../assets/v3/icons/time-zone-active.svg'
import { ReactComponent as TimeZoneInactiveIcon } from '../../assets/v3/icons/time-zone-inactive.svg'
import Autocomplete from '@material-ui/lab/Autocomplete'
import YumField from '../YumInput/YumInput'

export interface YumTimeZoneSelectProps extends YumSelectProps {
  useAutocompleteSelect?: boolean
}

export interface YumTimeZoneSelectOption {
  label: string
  value: any
  offset: string
}

const YumTimeZoneSelect: React.FC<YumTimeZoneSelectProps> = (props) => {
  const { useAutocompleteSelect, value, ...otherProps } = props
  const options: YumTimeZoneSelectOption[] = React.useMemo(() => getTimeZoneOptions(), [])
  return useAutocompleteSelect ? (
    <Autocomplete
      clearText={t`Clear`}
      closeText={t`Close`}
      openText={t`Open`}
      noOptionsText={t`No options`}
      openOnFocus
      onChange={(event, newValue) => {
        // @ts-ignore
        props.onChange?.({ target: { value: newValue?.value } }, null)
      }}
      options={options}
      value={options.find((option) => option.value === value) || null}
      getOptionLabel={(option) => option.label}
      /*getOptionSelected={(option, value) => option.value === value}*/
      renderInput={(params) => (
        <YumField
          {...params}
          label={props.label}
          style={props.style}
          startIcon={TimeZoneActiveIcon}
          startIconInactive={TimeZoneInactiveIcon}
          value={value}
          error={props.error}
          variant="filled"
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            // This disables the browser autocomplete.
            autoComplete: 'new-password',
          }}
          fullWidth={true}
          type="text"
        />
      )}
    />
  ) : (
    // @ts-ignore
    <YumSelect startIcon={TimeZoneActiveIcon} startInactiveIcon={TimeZoneInactiveIcon} value={value} {...otherProps}>
      {options.map((option: YumTimeZoneSelectOption, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </YumSelect>
  )
}

export default YumTimeZoneSelect
